import { Component, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ItemModel } from 'src/app/models/ItemModel';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import * as _ from 'lodash';
import { LogService } from 'src/app/services/log.service';
import { MatDialog } from '@angular/material/dialog';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { DashboardBusinessLogicService } from 'src/app/services/dashboard-business-logic.service';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import { InteractionDTO } from 'src/app/models/customer.model';
import { Tab } from 'src/app/models/tab.model';
import { CustomerAlertsService } from 'src/app/services/customer-alerts.service';
import { Subscription } from 'rxjs';
import { OnDemandEmailService } from 'src/app/services/on-demand-email.service';
import { ApiService } from 'src/app/services/api.service';
import { WrapUpData } from '../../../models/WrapUpData';
import { GEN_attributes } from '../../../models/customer.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  iconConfig: any;
  wrapUpPmtData:any;
  isDisplay = false;
  isShown: boolean = false;
  finalShowProfileCardVal: boolean = false;
  indicatorClass: string = 'gray';
  tbaIndicatorClass: string = 'gray';
  networkIndicatorClass: string = 'green';
  networkIndicatorSub!: Subscription;
  tbaIndicatorSub!: Subscription;
  public interactionModel: InteractionDTO = new InteractionDTO();
  className = "headerComponent";
  valEnable: any;
  valConnected: any;
  constants = Constants;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private genesysCloudService: GenesysCloudService,
    public rootScope: RootScopeService,
    public logger: LogService,
    public customerService: CustBusService,
    private initHistService: InteractionHistoryService,
    private custAlertsService: CustomerAlertsService,
    private dashboardService: DashboardBusinessLogicService,
    public custAccService: CustomerAccountBusinessLogicService,
    public onDemandEmailService: OnDemandEmailService,
    public apiService: ApiService
  ) {
    this.iconConfig = {
      iconName: 'xmark',
      iconType: 'light',
    };
  }

  ngOnInit(): void {
    this.rootScope.onResize();
    this.getGenesysConnectivityIndicatorClass();
    this.getNetworkIndicatorClass();
    this.getTbaIndicatorClass();
    this.listenWrapUpCompleteNotification();
  }

  /**
   * Below method is created as per ask to close 
   * the CA tab on click of close button in wrapup screeen. CCR1-3999.P
   * @author Pooja Gupta
   */

  listenWrapUpCompleteNotification() {
    this.rootScope.wrappedUpComplete.subscribe((data:any) => {
      if (data) {
        let index = -1;
        for (let i = 0; i < this.rootScope.customerTabs.length; i++) {
          if (this.rootScope.customerTabs[i]?.customerSessionId == this.rootScope.activeCustTab?.customerSessionId) {
            index = i;
            break;
          }
        }
        if (index != -1)
          this.closeTab(index, null, this.rootScope.activeCustTab,data?.accountToBeClosed);
        if (this.rootScope.isDuplicateCustSearchTabOpened)
          this.rootScope.isDuplicateCustSearchTabOpened = false;

      }
    })
  }

  /* istanbul ignore next */
  onTabChange(tab) {
    this.rootScope.isGensysUDPErrorToHide = true;
    this.rootScope.openViewParticipant = false;
    let items = [...this.rootScope.items];
    let selectedObj: any = null;
    let earlierSelectedItem: any = _.find(
      items,
      (each) => each.selected == true
    );
    earlierSelectedItem['selected'] = false;
    this.logger.log(this.rootScope.items);

    if (tab.id == Constants.CUSTOMER_SEARCH) {
      selectedObj = _.find(
        items,
        (each) => each.id == Constants.CUSTOMER_SEARCH
      );

      if (this.rootScope.customerLink == 0) {
        this.router.navigate(['/customer-search'], {
          skipLocationChange: true,
        });
      } else if (_.find(this.rootScope.customerTabs, (each) => each.id == 1 && each.customerSessionId == this.rootScope.customerLink)) {
        this.setActiveAccountDt(this.rootScope.customerLink);
        this.router.navigate([`/customer-search-unidentified-call/${this.rootScope.customerLink}`], {
          skipLocationChange: true,
        });
      } else {
        if (!this.rootScope.activeCustTab?.customerSessionId) this.setActiveAccountDt(this.rootScope.customerLink);
        this.router.navigate(
          [`/customer-account/${this.rootScope.customerLink}`],
          {
            skipLocationChange: true,
          }
        );
        
      }
      // this.rootScope.customerLink == 0
      //   ? this.router.navigate(['/customer-search'], {
      //       skipLocationChange: true,
      //     })
      //   : this.router.navigate(
      //       [`/customer-account/${this.rootScope.customerLink}`],
      //       {
      //         skipLocationChange: true,
      //       }
      //     );
      selectedObj['selected'] = true;
    } else if (tab.id == Constants.CCR_Dashboard) {
      this.router.navigate(['/'], { skipLocationChange: true });
      selectedObj = _.find(items, (each) => each.id == Constants.CCR_Dashboard);
      selectedObj['selected'] = true;
    }
    else if (tab.id == Constants.SIMULATION_MANAGER) {
      this.router.navigate(['/simulation-manager'], { skipLocationChange: true });
      selectedObj = _.find(items, (each) => each.id == Constants.SIMULATION_MANAGER);
      selectedObj['selected'] = true;
    }
    else if (tab.id == Constants.Administration) {
      this.router.navigate(['/administration'], { skipLocationChange: true });
      selectedObj = _.find(items, (each) => each.id == Constants.Administration);
      selectedObj['selected'] = true;
    }
    else {
      if (!this.rootScope.activeCustTab?.customerSessionId) this.setActiveAccountDt(this.rootScope.customerLink);
      this.router.navigate(
        [`/customer-account/${this.rootScope.customerLink}`],
        { skipLocationChange: true }
      );
      selectedObj = _.find(items, (each) => each.name == tab.name);
      if (selectedObj) selectedObj['selected'] = true;

    }

    this.rootScope.activeLink = selectedObj?.id;
    this.rootScope.items = items;
  }

  
  hideCloseIcon(tab) {
    if (tab.id == 0) return false;
    else if (!tab.active) return false;
    else if (!tab.closeIcon && this.checkLiveCloseIcon(tab)) return false;
    else if (!(tab.closeIcon && this.checkLiveCloseIcon(tab))) return true;
    else if (tab.isWrapupDone) return true;
    else return true;
  }


  checkLiveCloseIcon(tab) {
    let res = false;

    switch (true) {
      case tab.activeCall:
        res = true;
        break;
      case tab.activeChat:
        res = true;
        break;
      case !tab.wrappedupCroosIcon:
        res = true;
        break;

      case tab.makeAnotherCallCheckboxTicked:
        res = true;
        break;
      default:
        res = false;
        break;
    }
    return res;
  }


  /* istanbul ignore next */
  closeTab(index: any, event, tab, accountToBeClosed?:boolean) {
    event?.stopPropagation();
    this.valEnable =this.checkValEnable();
    if (tab.id == 1)
      this.rootScope.customerTabs.filter(function (each) { return each.customerSessionId != tab.conversationId })
    /**
     * when CSR try to close the primary account without closing the additional account
     *  to give an indication first user need to close the additional account first
     */
    if (tab?.additionalAccountId) {
      this.customerService.openAdditonalAcc = {
        id: tab.additionalAccountId,
        conversationId: tab.conversationId,
      };
      this.customerService.parentData = tab;
      if (this.rootScope.activeCustTab.idle) {
        this.customerService.idleTimeReset();
      } else if (this.rootScope.customDialogData.displayCustomDialogCA)
        this.rootScope.customDialogData.displayCustomDialogCA = false;

      this.customerService.mustCloseAddionalPopup(
        this.rootScope.customerLink != 0,
        tab.id
      );
    }
    else if (tab?.additionalAccount) {
      this.rootScope.customerTabs.forEach((x) => {
        if (
          x.additionalAccountId == tab.id &&
          x.conversationId == tab.conversationId
        ) {
          x.additionalAccountId = '';
          x.isAdditionalAccOpen = '';
        }
      });
     
      this.tabCloseCommonEvents(tab,accountToBeClosed);
      if(accountToBeClosed){
      // Close TBA,sqs,egain screens related to customer end 
        this.rootScope.customerTabs.splice(index, 1);
      // this.customerService.clearCustAccCache(tab);
      }
    }
    /**
   * care portal reach max count account when user close any account live call/chat
   * holding account land based on closing the account
   */
    else if (
      this.rootScope.checkMaxCustAccount() &&
      this.rootScope.holdLiveDetails[0]?.id
    ) {
      if (this.rootScope.holdLiveDetails[0]?.id != 1)
        this.customerService.openNewCustomerTab(
          this.rootScope.holdLiveDetails[0],
          ''
        );

      this.tabCloseCommonEvents(tab);
      this.rootScope.customerTabs.splice(index, 1);

      if (this.rootScope.holdLiveDetails.length == 1)
        this.rootScope.isLiveChat ? this.genesysCloudService.updateChatTabStatus(true, true) : this.customerService.updateCustTabStatus(true); //after landing the call/chat froozen the accounts
      // Below condition added to hold SL1 call data for CCR1-2683
      if (this.rootScope.holdLiveDetails[0]?.id == 1) {
        this.rootScope.customerTabs.splice(1, 0, this.rootScope.holdLiveDetails[0]);
        this.rootScope.displayRedIcon = true;
        if (this.rootScope.holdLiveDetails[0]?.title == Constants.unidentifiedCalls.Outbound && !(this.rootScope.isConference || this.rootScope.istransferred)) {
          //Updated For CCR3-4368
          this.customerService.handleOutboundCallDialingOrConnected();
          this.customerService.openRecordingDialPopUp();
        }
        //this.customerService.custAccService.openRecordDialog();
      }
      // Updated for CCR1-2683
      this.onSecondTabChange(
        this.rootScope.holdLiveDetails[0]?.id == 1
          ? this.rootScope.holdLiveDetails[0].customerSessionId
          : this.rootScope.customerLink, null, this.rootScope.holdLiveDetails[0]
      );
      this.rootScope.holdLiveDetails.shift(); //delete the hold data once account tab open in careportal
      // Updated for CCR3-721 & CCR3-3830
      if (this.rootScope.isLiveCall || this.rootScope.checkLiveChatAccount()) {
        this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
      }
    }

    else {
      this.tabCloseCommonEvents(tab,accountToBeClosed);
      if(accountToBeClosed){
        this.rootScope.customerTabs.splice(index, 1);
      }
      else{
        this.resetToResearchPage();
      }
      // this.customerService.clearCustAccCache(tab);
    }


    /* Any one tab is close in carportal focus shift to either in customer search tab or left tab of closing tab */
    if (this.rootScope.customerTabs.length == 1) this.onSecondTabChange(0, null, tab);
    else if (this.rootScope.customerLink == tab.customerSessionId) {
      let count = this.rootScope.customerTabs.length;
      let customerId =
        this.rootScope.customerTabs[count > index ? index : count - 1]
          .customerSessionId;
      // tab id of this customer id , if tab id equal to one then send tab.customerSessionId == customerId
      let tab = _.find(this.rootScope.customerTabs, (each) => each.customerSessionId == customerId);
      // Below use case is implemented for tab change when multiple unknown SL1 tab are open 
      if (tab?.id == 1) {
        this.onSecondTabChange(tab.customerSessionId, null, tab);
      } else {
        this.onSecondTabChange(customerId, null, tab);
      }

    }
  }

/**CCR1-15200 */
  resetToResearchPage(){
    // let data = {
    //   "row":{
    //     "customerSessionId": this.rootScope.customerLink,
    //     "customerType": this.rootScope.activeCustTab.customerType,
    //     "clientId": this.rootScope.activeCustTab.clientId
    //   }
    // }
    // this.customerService.getPersonData(data,null,this);

      // this.rootScope.clonedActiveCustTab = _.cloneDeep(this.rootScope.activeCustTab);
      // this.rootScope.activeCustTab = new Tab();
      // this.rootScope.activeCustTab.customerSessionId = this.rootScope.customerLink;
      // this.rootScope.activeCustTab.customerType = this.rootScope.clonedActiveCustTab.customerType;
      // this.rootScope.activeCustTab.clientId = this.rootScope.clonedActiveCustTab.clientId;
      // this.rootScope.activeCustTab.authenticationContents = _.cloneDeep(this.rootScope.clonedActiveCustTab.authenticationContents);
      // this.rootScope.activeCustTab.VALData = _.cloneDeep(this.rootScope.clonedActiveCustTab.VALData);
      this.rootScope.activeCustTab.activeCall = false;
      this.rootScope.activeCustTab.activeChat = false;
      this.rootScope.activeCustTab.iconClass = '';
      this.rootScope.activeCustTab.CS_SECURITY_LEVEL = Constants.securityLevels.SL0;
      this.rootScope.activeCustTab.authenticateStatus = Constants.Not_Applicable;
      this.rootScope.activeCustTab.wrapUpData = new WrapUpData();
      this.rootScope.activeCustTab.channel = Constants.conversion.research;
      this.rootScope.activeCustTab.conversationId  = '';
      this.rootScope.activeCustTab.externalLeaveId = 'NA';
      this.rootScope.activeCustTab.personId = 'NA';
      this.rootScope.activeCustTab.startSL = Constants.Not_Applicable;
      this.rootScope.activeCustTab.Config_DesktopIndicator = '';
      this.rootScope.activeCustTab.interactionDisconnected = false;
      this.rootScope.activeCustTab.closeIcon = true;
      this.rootScope.activeCustTab.genesysAttributes = new GEN_attributes();

      let payload = {
        'customerSessionId': this.rootScope.activeCustTab.customerSessionId,
        'cusTab': { ...this.rootScope.activeCustTab }
      }
      this.customerService.updateCustomerInElasticCache(payload);
      this.rootScope.moveToOverViewTab.next(true);
      


  }

  /* ccr1-8418*/
  checkValEnable(): boolean {
    const selectedContents = this.rootScope.activeCustTab.authenticationContents.selectedAuthenticationContent;
    
    if (Array.isArray(selectedContents)) {
      let test = selectedContents.some(content => content.securityMethodCode === Constants.AuthCode.VAL);
      this.valConnected = this.rootScope.activeCustTab.VALData?.step2Complete;
      if( test && this.valConnected){
        return true
      } 
      
    }

    return false;
  }
  /**
   * @author VamsiKrishna
   * @param tab which need to close 
   * delete Ih data
   * IH sqs api will trigger for all research,call,chat all flows
   * Angular logs for teleyphone events and link tracking SQS Apis 
   * Close time update in elastic caches api
   * close TBA windows functions will excuted 
   */

  tabCloseCommonEvents(tab,accountToBeClosed?: boolean) {

    if(accountToBeClosed) {   //added as part of CCr1-15200
      this.initHistService.deleteEntryIHMap(tab.customerSessionId);
      this.custAlertsService.deleteEntryCustAlertMap(tab.customerSessionId);
      this.initHistService.transferredDataArr = [];
    }

    if (!tab.additionalAccount) {
      this.rootScope.closeKCWindow(tab);
      this.rootScope.closeExternalTabs(tab);
    }


    if (tab.channel == Constants.conversion.research) {
      this.captureResearchModeData(tab);
      //this.customerService.clearCustAccCache(tab);
      this.deleteCustomerSessionId(tab);
    } else if (tab.additionalAccount) {
      //To maintain interaction history in SQS logs when user close additional account
      /*since CCR3-1911 pushing the interaction details on customer tab closure event*/
      this.customerService.closeAccountApiReq(tab);

      /*Added below check to fix the bug CCR1-4906*/
      if (this.rootScope.customDialogData.displayCustomDialogCS)
        this.rootScope.customDialogData.displayCustomDialogCS = false;
    }
    /*since CCR3-1911 pushing the interaction details on customer tab closure event*/
    else if (tab.conversationId != "NA" && !tab.additionalAccount && tab.channel != Constants.conversion.research) {
      if (this.rootScope.multiAccountsMap.get(tab.conversationId)
        && !this.rootScope.interactionsMap.get(tab.customerSessionId)?.buckets?.find(x => x?.keyName == Constants.MULTI_ACCOUNT_RECORDS)) {
        this.genesysCloudService.updateMultiAccountInteractionRecords(tab);
      }
      if (this.rootScope.interactionsMap.get(tab.customerSessionId)) {
        /**CCR3-7670 - ALS update during wrapup for call/chat*/
        if (tab?.id != 1 && tab?.interactionDisconnected) {
          this.customerService.upadateALSAttributeInWrapUp(this.processWrapUpTopic(tab.wrapUpData?.primaryTopic));
        }


        /*CCR1-12960: Build comprehensive AI wrap-up audit log (captures all required audit fields).This log is emitted when wrap-up is completed/account closed, combining AI metadata with final saved state.*/
        const aiMeta = tab?.['_aiSummaryMetadata'] || {};
        const finalSavedComments = tab?.wrapUpData?.comments || '';
        const aiGeneratedComments = aiMeta?.aiGeneratedComments || '';

        const normalizeComments = (text) => (text || '')?.replace(/\s+/g, ' ')?.trim()

        const aiBaselineTopics = aiMeta?.topicsBaselineAtRetrieval || [];
        const hasValidAITopics = aiMeta?.aiRetrievalUsed === true && Array.isArray(aiBaselineTopics) && aiBaselineTopics.length > 0;

        // Extract final saved topics from wrapupTopicList
        const finalSavedTopics = (tab?.wrapUpData?.wrapupTopicList || []).map(topic => ({
          domain: topic?.domain,
          topic: topic?.topic,
          subTopic: topic?.subTopic
        }));

        const aiTopicRemoved = aiBaselineTopics.some(aiTopic =>
          !finalSavedTopics.some(finalTopic =>
            finalTopic?.domain === aiTopic?.domain &&
            finalTopic?.topic === aiTopic?.topic &&
            finalTopic?.subTopic === aiTopic?.subTopic
          )
        );

        const topicsAddedAfterAI = hasValidAITopics && finalSavedTopics.some(finalTopic =>
          !aiBaselineTopics.some(aiTopic =>
            aiTopic?.domain === finalTopic?.domain &&
            aiTopic?.topic === finalTopic?.topic &&
            aiTopic?.subTopic === finalTopic?.subTopic
          )
        );

        const primaryTopicChanged = tab?.['_aiSummaryMetadata']?.aiPrimaryTopic !== tab?.wrapUpData?.primaryTopic;
        const commentsModified =
          aiMeta?.aiRetrievalUsed === true && !normalizeComments(finalSavedComments)?.includes(normalizeComments(aiGeneratedComments));
        const topicsModified = hasValidAITopics && (aiTopicRemoved || topicsAddedAfterAI || primaryTopicChanged);
        // CCR1-12960: Determine source: Wrap-up Page vs Unknown Caller Detail
        const source = tab?.wrapUpData?.unknownCallerWrapupPage ? Constants.UNKNOWN_PAGE : Constants.WRAP_UP_PAGE;
        const pptName = tab?.wrapUpData?.unknownCallerWrapupPage ? tab?.wrapUpData?.unknownCustomerName : tab?.title;

         /*CCR1-12960 AI summary logging changes ended*/

        /** Below code  update current tab IH Object with wrapupData CCR1-3999*/
        let interactionEventDTO = this.rootScope.interactionsMap.get(tab.customerSessionId);
        interactionEventDTO.description = tab.wrapUpData?.primaryTopic;
        interactionEventDTO.details = tab.wrapUpData?.comments;
        /**Below condition added for handling the SL1 Unknown call CCR1-5017*/
        if (tab.CS_SECURITY_LEVEL == 0) {
          if (!interactionEventDTO.contact) {
            interactionEventDTO.contact = {};
          };
          interactionEventDTO.contact.name = tab?.wrapUpData?.contactName;
          interactionEventDTO.contact.phoneNumber = tab?.tabData?.phoneNumber;
          interactionEventDTO.contact.type = tab?.wrapUpData?.unknownCallerType;
        }
        let obj = { "keyName": Constants.WRAP_UP_KEY_BUCKET, "keyValue": this.getWrapUpDataToSaveinIH(tab) }
        interactionEventDTO.buckets?.push(obj);

        /**Below condition added if CSRs having two active calls simultaneously for same PPT - CCR3-12436*/
        if (this.rootScope.activeCustTab && this.rootScope.activeCustTab?.['agentDetails'] && this.rootScope.activeCustTab['agentDetails']?.delegate?.delegateId) {
          let simultaneousCallsObj = { [Constants.BUCKET_KEY_NAME]: Constants.SIMULTANEOUS_CALL_KEY_BUCKET, [Constants.BUCKET_KEY_VALUE]: Constants.SIMULTANEOUS_CALL_VALUE_BUCKET }
          interactionEventDTO.buckets?.push(simultaneousCallsObj);
        }

        let interactionEventDTOClone = Object.assign({}, interactionEventDTO);

        console.log('Interaction model captured to be send to SQS-additional account scenario' + JSON.stringify(interactionEventDTOClone));
        
        // ✅ Clean up blank values
        this.customerService.removeIHBlankValues(interactionEventDTOClone);
    
        this.genesysCloudService.awsSQSService.sendInteractionHistoryToSQS(interactionEventDTOClone);

         // CCR1-12960: Build comprehensive AI wrap-up finalization audit log with all audit fields
        let aiFinalAudit: any = {
          eventType: 'WRAP_UP_SUMMARY',                              
          timeStamp: interactionEventDTOClone.created,
          agentID: this.rootScope.lanId || sessionStorage.getItem('lanId'),                         
          conversationId: tab?.conversationId, 
          clientName: this.rootScope.getClientName(tab?.clientId),   
          participantName: pptName,       
          udpId: tab?.tabData?.tabData?.globalPersonIdentifier || '',              
          aiRetrievalUsed: aiMeta?.aiRetrievalUsed==true ? 'Yes' : 'No',                                    
          commentsChanged: commentsModified ? 'Yes' : 'No',                                                        
          wrapUpTopicsChanged: topicsModified ? 'Yes' : 'No',                                 
          source: source, 
        };
        
        this.logger.debugLogs("Logging Wrap Up details for AI summary feature usage =" + JSON.stringify(aiFinalAudit), this.className);
        let newObj = this.rootScope.createLogsObject(JSON.stringify(aiFinalAudit), "telephony", this.rootScope.activeCustTab,this.rootScope.activeCustTab.conversationId);
        this.genesysCloudService.awsSQSService.sendAngularLogsToSQS(newObj);

        
      }
    
      // console.log('key ' + key + ' tab.conversationId ' + tab.conversationId);
      if (tab.CS_SECURITY_LEVEL != 0 && accountToBeClosed) {
        //this.customerService.clearCustAccCache(tab);
        this.deleteCustomerSessionId(tab);
    }

    }

    //Close TBA screens related to customer start
    this.customerService.closeCustomerTbaScreens(tab);

    //close customer documents
    this.customerService.closeCustomerDocuments(tab);

    this.sendCustomerDataToAngularLogsSQS(tab);
    // this.sendTelephonyEventsAngularLogsSQS(tab);
    // Handle closing of multi-account tabs if present
    this.closeMultiAccounts(tab);
   
  }
  
  /* CCR1-8418*/
  deleteCustomerSessionId(tab: any) {
    if (this.valEnable) {
      /* CCR1-8418: This relock API is used for the Val Flow process */
      this.apiService.getValRelockApi(tab.customerSessionId).subscribe({
        next: (data: any) => {
          this.customerService.clearCustAccCache(tab);
        },
        error: (error) => {
          this.logger.errorLogs('Error in getRelockApi'+error, this.className);
          this.customerService.clearCustAccCache(tab);
        }
      });

    }else{
     this.customerService.clearCustAccCache(tab);
    }
  }

  
/**
 * Method will extract the primary topic and sub topic from available string by eliminating symbols
 * @param topic string with selected primary topic details from wrap up section
 * @returns primary topic & subtopic 
 * @author Hashid
 */
  processWrapUpTopic(topic) {
    let primaryTopics = topic.split(">>");
    let wrapUpPmtData = primaryTopics[1];
    let wrapUpPstData = primaryTopics[2];
    return { wrapUpPmtData, wrapUpPstData };
 }


  getWrapUpDataToSaveinIH(tab) {
    let wrapUpDataDTO = tab?.wrapUpData;
    let obj = _.cloneDeep(wrapUpDataDTO);
    let topicList = wrapUpDataDTO?.wrapupTopicList.filter(function (each) {
      return wrapUpDataDTO.primaryTopic != each?.domain + Constants.TOPIC_ARROW + each?.topic + Constants.TOPIC_ARROW + each?.subTopic;
    });

    let counter = 1;
    topicList.map(function (each) {
      each['order'] = counter;
      counter = counter + 1;
      delete each?.id;
    })

    // CCR1-12455: Consolidate internal "where" fields into a single IH payload field.
    if (wrapUpDataDTO?.whereSingleSelect) {
      wrapUpDataDTO.where = wrapUpDataDTO?.whereSingleSelect;
    } else if (Array.isArray(wrapUpDataDTO?.whereMultiSelect) && wrapUpDataDTO?.whereMultiSelect?.length) {
      wrapUpDataDTO.where = wrapUpDataDTO?.whereMultiSelect?.join(', ');
    } else {
      wrapUpDataDTO.where = '';
    }

    /**Below condition added for handling the SL1 Unknown call CCR1-5017*/
    if (tab.CS_SECURITY_LEVEL == 0) {
      wrapUpDataDTO.wrapupTopicList = topicList
      delete wrapUpDataDTO['interactionFeedback'];
      delete wrapUpDataDTO['interactionMode'];
    } else {
      wrapUpDataDTO.wrapupTopicList = topicList
      delete wrapUpDataDTO['unknownCustomerName'];
    }

    wrapUpDataDTO.wrapupTopicList = topicList
    delete wrapUpDataDTO['primaryTopic'];
    delete wrapUpDataDTO['comments'];
    delete wrapUpDataDTO['contactName'];
    delete wrapUpDataDTO['previousUknownCallerType'];
    delete wrapUpDataDTO['unknownCallerType'];
    delete wrapUpDataDTO['unknownCallerWrapupPage'];
    // CCR1-12455: Drop the internal-only fields from IH payload
    delete wrapUpDataDTO['whereSingleSelect'];
    delete wrapUpDataDTO['whereMultiSelect'];
    

    return wrapUpDataDTO;
  }

  /* istanbul ignore next */
  onSecondTabChange(id, event?, tab?) {
    //this.rootScope.openCreateAlertDialog = false;
    this.rootScope.isGensysUDPErrorToHide = true;
    // console.log('id = ', tab);
    this.rootScope.customerLink = id + '';//SHOW_PERSON
    /**CCR3-3401
      * @author Vamsi.pamidala
      * to handle tba hide and show condiions 
      */
    this.rootScope.hideAndShowTBA(Constants.TBA_COMMANDS.HIDE, id);
    this.rootScope.showAndHideCustomerDocuments(tab);
    if (id == 0) {
      this.router.navigate(['/customer-search'], { skipLocationChange: true });
      this.rootScope.activeCustTab = new Tab();
    } else if (tab?.id == '1' && id == tab?.customerSessionId) {
      this.setActiveAccountDt(id);

      this.router.navigate([`/customer-search-unidentified-call/${id}`], {
        skipLocationChange: true,
      });
    } else {
      this.setActiveAccountDt(id);
      /**Below method call for CCR1-6569 for OnDemandEmail data retention */
      this.updateOnDemandEmailDataForTabChange();
      this.router.navigate([`/customer-account/${id}`], {
        skipLocationChange: true,
      });


      // this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
      //   this.rootScope.customerTabs,
      //   'customerSessionId',
      //   id
      // );
      //this.customerService.csAcRouting.next({ _id: id });
    }
    if (this.rootScope.customDialogData.displayCustomDialogCA && event)
      this.rootScope.customDialogData.displayCustomDialogCA = false;
  }

  
  getClassByValue(tab) {
    // console.log("method getClassByValue called ",tab)
    let cls = '';
    if (tab.id == 0) cls = '';
    else {
      switch (true) {
        case !tab.active:
          cls = 'frozen';
          break;
        case tab.idle && !this.rootScope.checkCallOrChat():
          cls = 'idle';
          break;
        default:
          cls = '';
          break;
      }
    }
    return cls;
  }
  /* istanbul ignore next */
  /**Below method subscribe the _presenceStatus of GenesysCloudService and
   * took the presence value and set the indicatorClass as per Presence Status*/
  getGenesysConnectivityIndicatorClass() {
    this.genesysCloudService._presenceStatus.subscribe({
      next: (presence: string) => {
        if (
          presence == Constants.ALIS_PRESENCE.Offline1 ||
          presence == Constants.ALIS_PRESENCE.Offline2
        ) {
          this.indicatorClass = 'gray';
          this.rootScope.indicatorClass = 'gray';
          this.rootScope.enableAlerts(
            Constants.WARNING,
            Constants.ALIS_OFFLINE_MSG
          );
        } else if (presence == Constants.ALIS_PRESENCE.ALISConnectionError) {
          this.indicatorClass = 'red';
          this.rootScope.isWarningToHide = true;
          this.rootScope.indicatorClass = 'red';
        } else {
          this.indicatorClass = 'green';
          this.rootScope.indicatorClass = 'green';
          this.rootScope.isWarningToHide = true;
          this.rootScope.isGENSYSErrorToHide = true;
        }
      },
      error: (error) => { },
    });
  }

  /* istanbul ignore next */
  /**Below method subscribe the speed Observable of rootScopeService and
   * took the network speed value and set the networkIndicatorClass as per network speed*/
  getNetworkIndicatorClass() {
    this.networkIndicatorSub = this.rootScope.speed.subscribe({
      next: (speed: number) => {
        this.logger.log(
          'speed in header : speedThreshold :' +
          this.rootScope.speedThreshold +
          ', speed :' +
          speed
        );
        if (this.rootScope.isNetworkOnline == true) {
          if (speed >= this.rootScope.speedThreshold) {
            this.networkIndicatorClass = Constants.NETWORK_COLOR_GREEN;
          } else {
            this.networkIndicatorClass = Constants.NETWORK_COLOR_YELLOW;
          }
        } else {
          this.networkIndicatorClass = Constants.NETWORK_COLOR_RED;
          this.rootScope.tbaIndicatorClass.next(
            Constants.TBA_INDICATOR_COLOR.RED
          );
          this.rootScope.TBAGUIHealthCheckError = true;
          this.rootScope.TBAGUIConnected = false;
        }
      },
      error: (error) => { },
    });
  }

  /**Below method subscribe the tbaIndicatorClass Observable as its hold the class name(color) of
   * TBA Indicator by checking the connectivity of TBA GUI through hitting backend service*/
  getTbaIndicatorClass() {
    this.tbaIndicatorSub = this.rootScope.tbaIndicatorClass.subscribe({
      next: (tbaClass: string) => {
        if (tbaClass == "red" && this.rootScope.TBAGUIAuthenticated) this.rootScope.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);

        this.tbaIndicatorClass = tbaClass;
      },
      error: (error) => { },
    });
  }

  liveIcon(tab, type) {
    return this.rootScope.liveIcon(tab, type);
  }

   /**CCR1-4583
    * @author Hashid
    *checkForDuplicateSearch()- Method to to check any duplicate search method is enbled in customer tab.
     return the true for enbaling the class to nav
    */
     checkForDuplicateSearch(): boolean {
    return this.rootScope.customerTabs.some(tab => tab.id === 1)
  }

  /**CCR1-4329
    * @author Amarjeet
    *callHollowIcon()-Method to show hollow call icon after call disconnected
    */
  callHollowIcon(tab) {
    if (tab.interactionDisconnected && !tab.isWrapupDone)
      return true
    else return false;
  }
  
  chatHollowIcon(tab) {
    if (tab.interactionDisconnected && tab.isWrapupDone)
      return true
    else return false;
  }


  /**To set activate tab details in customer account */
  setActiveAccountDt(id) {

    this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
      this.rootScope.customerTabs,
      'customerSessionId',
      id
    );




    /**CCR3-3401
      * @author Vamsi.pamidala
      * to handle tba hide and show condiions 
     */
    this.rootScope.hideAndShowTBA(Constants.TBA_COMMANDS.SHOW, id);

    /**Added below line to handle CCR1-5659(On tab switch handling/retaining selected row) */
    this.rootScope.clonedActiveCustTab = new Tab();
    this.rootScope.clonedActiveCustTab = _.cloneDeep(this.rootScope.activeCustTab);

  }


  /**
   * This function is used to capture and send research mode data and send to aws SQS.
   * @param tabdt 
   */
  captureResearchModeData(tabdt: Tab) {

    this.interactionModel = new InteractionDTO();
    /**
     * Added to check to send data of research mode account data  only
     */
    if (tabdt.conversationId != 'NA') {
      return;
    }
    let res: any;
    if (tabdt) {
      /// tabdt.endSL = tabdt.authenticateStatus
      res = tabdt?.tabData?.tabData;
    }

    this.interactionModel.created = new Date(tabdt?.startTime)?.toISOString() || new Date().toISOString();
    //this.interactionModel.externalRefId = 'N/A';
    this.interactionModel.begin = tabdt.startTime;
    this.interactionModel.end = new Date().toISOString();
    this.interactionModel.channel = 'offcall';
    this.interactionModel.clientId = this.rootScope.checkClientSystemMappingAndReplace(tabdt?.clientId);//tabdt.clientId;
    this.interactionModel.initiated = 'internal';
    this.interactionModel.system = 'careportal';
    this.interactionModel.description = 'Account Research';

    this.interactionModel.delegate = {
      name: this.rootScope.firstName + ' ' + this.rootScope.lastName,
      delegateId: this.rootScope.lanId,
      phoneNumber: 'N/A',
      emailAddress: this.rootScope.emailId,
      telephonyId: 'N/A'
    }
       // this.interactionModel.subject = {
    //   id: tabdt?.id,
    //   firstName: res?.firstName,
    //   lastName: res?.lastName,
    //   // type: tabdt?.defaultRole,
    // };

    this.interactionModel.contact = {
      id: tabdt?.id,
      name: tabdt?.title,
      type: tabdt?.customerType,
      phoneNumber: 'N/A',
      emailAddress: 'N/A',
      ipAddress: 'N/A',
      role: tabdt?.defaultRole,
    };
    console.log('Interaction Model for Research Mode: ' + JSON.stringify(this.interactionModel))
    
// ✅ Clean up blank values
  this.customerService.removeIHBlankValues(this.interactionModel);

    this.genesysCloudService.awsSQSService.sendInteractionHistoryToSQS(this.interactionModel);
  }

  sendCustomerDataToAngularLogsSQS(tab) {

    let linkMessageString = this.rootScope.linkTrackingMap?.get(tab?.id);

    if (linkMessageString) {
      this.rootScope.linkTrackingMap?.delete(tab?.id);
      let logObj = this.rootScope.createAngluarLogsObject(linkMessageString, 'usage', tab);
      this.genesysCloudService.awsSQSService.sendAngularLogsToSQS(logObj);
    }

    this.sendTelephonyEventsAngularLogsSQS(tab);

  }

  sendTelephonyEventsAngularLogsSQS(tab) {
    let telephonyEventMessage = this.rootScope.liveInteractionLogs?.get(tab?.conversationId);

    if (telephonyEventMessage) {
      this.rootScope.liveInteractionLogs?.delete(tab?.conversationId);
      this.logger.debugLogs(telephonyEventMessage,this.className);//CCR5-6188 log add In TBA
      // let livelogObj = this.rootScope.createAngluarLogsObject(telephonyEventMessage, "telephony", tab);
      // this.genesysCloudService.awsSQSService.sendAngularLogsToSQS(livelogObj);
    }
    // let telephonyEventDebugDTO = this.rootScope.telephonyEventDebugDTO;
    // if (telephonyEventDebugDTO) {
    //   this.genesysCloudService.awsSQSService.sendAngularLogsToSQS(telephonyEventDebugDTO);
    // }
  }


  /**Below method call all the method for On-Demand Email page when user switch the Customer Account Tabs*/
  updateOnDemandEmailDataForTabChange(){
    this.onDemandEmailService.createOnDemandEmailForm();
    this.onDemandEmailService.retainOnDemandEmailDataForTabChange();
  }

  /**
   * Closes all tabs associated with a multi-account conversation, except for the current tab.
   *
   * This method performs the following actions:
   * - Retrieves the list of account tab IDs associated with the given conversation ID from `multiAccountsMap`.
   * - If the accounts array exists, is non-empty, and the current tab is not an additional account:
   *   - Removes the current tab's ID from the accounts array.
   *   - Deletes the conversation entry from `multiAccountsMap`.
   *   - Iterates over the remaining account tab IDs and closes each corresponding tab
   *     (with a slight delay using `setTimeout`).
   *CCR3-13182
   * @param tab The tab object representing the current tab to be closed. Must contain `id`, `conversationId`, and optionally `additionalAccount`.
   */
  closeMultiAccounts(tab) {
    const accounts = this.rootScope.multiAccountsMap.get(tab.conversationId);

    if (Array.isArray(accounts) && accounts?.length > 0 && !tab.additionalAccount) {
      // Remove the current tab id from the accounts array
      const idx = accounts.indexOf(tab.id);
      if (idx !== -1) {
        accounts.splice(idx, 1);
      }

      // If there are other accounts, close their tabs
      if (accounts?.length > 0) {
       
          const tabIndex = this.rootScope.customerTabs.findIndex(
            t => t.id === accounts[accounts.length-1] && t.conversationId === tab.conversationId
          );

          if (tabIndex !== -1) {
            const targetTab = this.rootScope.customerTabs[tabIndex];
            if (targetTab?.additionalAccountId) {
              targetTab.wrappedupCroosIcon = true;
            } else {
              setTimeout(() => {
                this.closeTab(tabIndex, null, targetTab);
              }, 100);
            }
          }
       
      }

      // Clean up the map if no accounts remain
      if (accounts.length === 0) {
        this.rootScope.multiAccountsMap.delete(tab.conversationId);
      }
    }
  }

  ngOnDestroy() {
    this.rootScope.items = [
      { name: 'My Dashboard', selected: true, id: 'dashboard' },
      { name: 'Customer Accounts', selected: false, id: 'search' },
      //{ name: 'Simulation Manager', selected: false, id: 'simulation' }
    ];
    this.rootScope.activeLink = Constants.ACTIVE_TAB;
    this.networkIndicatorSub.unsubscribe();
    this.tbaIndicatorSub.unsubscribe();
    this.dashboardService.stopTbaConnectivityInterval();    
  }

}
